import React from "react";
import { LoginCallback } from "@okta/okta-react";

interface Props
{
  loadingView?: React.ComponentType<{}>;
  errorView?: React.ComponentType<{error: Error}>;
}
export const OpenIdLoginCallback: React.FC<Props> = ({loadingView, errorView}) =>
{
  const LoadingViewCompoent = loadingView;
  return <LoginCallback loadingElement={LoadingViewCompoent ? <LoadingViewCompoent /> : undefined} errorComponent={errorView} />;
}
